import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";

interface FlavorItem {
  id?: string;
  name: string;
  emoji?: string;
}

interface Props {
  flavors: FlavorItem[];
  selected: string[];
  onChange: (ids: string[]) => void;
}

export const PizzaFlavorSelector = ({
  flavors,
  selected,
  onChange,
}: Props) => {
  const toggle = (id: string) => {
    onChange(
      selected.includes(id)
        ? selected.filter((x) => x !== id)
        : [...selected, id]
    );
  };

  return (
    <List dense>
      {flavors.map((flv) => {
        const flvId = flv.id || flv.name;
        return (
          <ListItem key={flvId} disablePadding>
            <ListItemButton onClick={() => toggle(flvId)}>
              <Checkbox checked={selected.includes(flvId)} />
              <ListItemText primary={`${flv.emoji || '🍕'} ${flv.name}`} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};
